import React, { useEffect, useState } from 'react'
import Footer from '../main/Footer';
import ProfileSidebar from './ProfileSidebar';
import CommonHeader from './CommonHeader';
import DesktopHeader from '../main/DesktopHeader';
import PageName from './PageName';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';


const CommonLayoutStructure = (props) => {
   const [count, setCount] = useState(0);
  const getnotification = async () => {
      try {
       
        const response = await callAPI(apiUrls.unreadcount, {}, "GET", {});
        if (response?.data?.success) {
          setCount(response?.data?.data?.unread_count || 0);
        }
      } catch (e) {
        console.error(e);
      } finally {
       
      }
    };
   const token = localStorage.getItem("accessToken");
    useEffect(() => {
      if(token){
        getnotification();
      }
     
      // eslint-disable-next-line
    }, []);
  return (
    <>
<CommonHeader count={count}/>
<DesktopHeader  count={count}/>
 <div className="dashboard-page ">
  <div className="container">
    <div className="dashboard-layout ">

      {/* LEFT SIDEBAR */}
   <ProfileSidebar/>

      {/* RIGHT MAIN CONTENT */}
      <main className="dashboard-content">
        <PageName/>
   {props.children}

      </main>

    </div>
  </div>
</div>
<Footer/>
</>
  )
}

export default CommonLayoutStructure;